import {
  RESUBMISSION_LOADING,
  RESUBMITTED_LOADED,
  RESUBMITTED_SEARCH,
  RESUBMISSION_QUEUED,
  RESUBMISSION_STATS,
  RESUBMITTED_FAILED,
  AUTH_FAILED,
  LOGOUT,
} from "../types";

const initialState = {
  loading: false,
  resubmitted: [],
  searchResults: [],
  stats: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESUBMISSION_LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESUBMISSION_QUEUED:
      return {
        ...state,
        loading: false,
        status: null,
      };
    case RESUBMISSION_STATS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
      };
    case RESUBMITTED_LOADED:
      return {
        ...state,
        loading: false,
        resubmitted: action.payload,
        status: null,
      };
    case RESUBMITTED_SEARCH:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
        status: null,
      };
    case RESUBMITTED_FAILED:
      return {
        ...state,
        loading: false,
        status: null,
      };
    case AUTH_FAILED:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
